export default __webpack_public_path__ + "static/appicon256-5c467b7a49f4e73d630ebb84d0d4e713.png";